<template>
  <jc-popup v-model="open" direction="bottom">
    <div class="sku-wrapper">
      <div class="sku-header">
        <img @click.stop="showImage" class="sku-img" alt="商品图" v-if="currentValue[opts.value.img.key]" :src="currentValue[opts.value.img.key][opts.value.img.url]">
        <div class="sku-summary">
          <p class="sku-name">{{prodName}}</p>
          <p class="sku-spec">{{spu[opts.spu.sub]}}</p>
          <span class="sku-price">{{currentValue[opts.value.price]}}</span>
        </div>
        <i class="jc-icon icon-cancel closer" @click.stop="open = false"></i>
      </div>
      <div class="sku-body">
        <dl class="sku-props" v-for="s in currentProps" :key="s[opts.sku.key]">
          <dt class="sku-props-name">{{s[opts.sku.attrName]}}</dt>
          <dd class="sku-props-item"
            @click="handleChangeProp(u, s[opts.sku.key])"
            v-for="u in s[opts.sku.children]"
            :class="{active: u.$selected,
            disabled: u.$disabled}"
            :key="u[opts.sku.id]"><span>{{u[opts.sku.name]}}</span>
          </dd>
        </dl>
        <jc-cell title="数量" class="nums"><div class="nums-input" slot="append" ><van-stepper v-model="nums" integer: min="1"/><span class="unit">&nbsp;{{spu[opts.spu.unit]}}</span></div></jc-cell>
      </div>
      <div class="sku-footer">
        <jc-btn :disabled="!ready" class="add2cart" size="lg" half right-angle @click="add(addCart)" :loading="loading"><div class="primary-btn-center">加入购物车</div></jc-btn>
        <jc-btn :disabled="!ready" class="buy-now" size="lg" half right-angle :loading="loading" @click="add"><div class="primary-btn-center">立即购买</div></jc-btn>
      </div>
    </div>
  </jc-popup>
</template>

<script>
import scrollLocker from '@/utils/scroll-lock'
import types from '@/store/types'
import {mapGetters} from 'vuex'
import _ from 'lodash'
export default {
  name: 'jc-sku',
  props: {
    visible: Boolean,
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    spu: { // spu信息 包括计量单位 商品名称 副标题
      type: Object,
      default () {
        return {}
      },
      required: true
    },
    props: {
      type: Array,
      default () {
        return []
      },
      required: true
    },
    sku: {
      type: Array,
      default () {
        return []
      },
      required: true
    },
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      open: false,
      currentValue: '',
      currentProps: [],
      opts: {
        value: {
          id: 'id',
          attrs: 'allAttrs',
          attrText: 'attrVals',
          img: {
            key: 'mainImg',
            url: 'imgUrl'
          },
          name: 'prodName',
          price: 'salePrice'
        },
        sku: {
          attrName: 'attrName',
          key: 'attrId',
          children: 'children',
          id: 'attrValue',
          name: 'attrValue'
        },
        list: {
          id: 'id',
          price: 'salePrice',
          name: 'prodName'
        },
        spu: {
          name: 'name', // 商品名称
          id: 'id',
          brand: 'brand',
          sub: 'sub', // 副标题
          unit: 'unit' // 单位
        }
      },
      keys: [],
      values: {},
      matchProduct: {},
      nums: 1,
      loading: false,
      valuesCache: [],
      allSkus: [],
      currentSku: {}
    }
  },
  computed: {
    attrText () {
      let values = []
      for (let key in this.currentSku) {
        if (this.values.hasOwnProperty(key)) {
          values.push(this.values[key])
        }
      }
      return values.join('/')
    },
    attrs () {
      let values = []
      for (let key in this.currentSku) {
        if (this.values.hasOwnProperty(key)) {
          // 从属性集合中获取属性名
          this.props.forEach(prop => {
            if (prop[this.opts.sku.key] == key) {
              values.push({
                attrName: prop[this.opts.sku.attrName],
                attrValue: this.values[key]
              })
            }
          })
        }
      }
      return values
    },
    prodName () {
      return `${this.currentValue[this.opts.value.name]} ${this.currentValue.attrVals}`
    },
    ready () {
      return this.keys.length === this.currentProps.length
    },
    ...mapGetters(['user'])
  },
  watch: {
    options: {
      immediate: true,
      handler () {
        this.opts = _.merge({}, this.opts, this.options)
      }
    },
    visible: {
      immediate: true,
      handler () {
        this.open = this.visible
      }
    },
    open () {
      if (!this.open) {
        scrollLocker.unlock()
        this.$emit('update:visible', false)
      } else {
        scrollLocker.lock()
      }
    },
    value () {
      this.init()
    },
    sku: {
      immediate: true,
      deep: true,
      handler () {
        this.init()
      }
    },
    props: {
      deep: true,
      immediate: true,
      handler () {
        if (this.props) {
          this.currentProps = JSON.parse(JSON.stringify(this.props))
          this.currentProps.forEach(p => {
            p.children.forEach(attr => {
              attr.$parent = p[this.opts.sku.key]
            })
          })
          this.init()
        }
      }
    },
    list: {
      immediate: true,
      deep: true,
      handler () {
        this.init()
      }
    }
  },
  methods: {
    showImage (e) {
      this.$createImagePreview({
        imgs: [e.target.src],
        initialIndex: 0,
        loop: false,
        speed: 500,
        zIndex: 999999
      }).show()
    },
    /**
     * @description 初始化，生成所有的属性和匹配当前sku
     */
    init () {
      if (!this.value || !this.sku || !this.props) return
      this.currentValue = this.value
      // 获取所有的sku属性id
      this.keys = []
      this.currentProps.forEach(k => {
        this.keys.push(k[this.opts.sku.key])
      })
      // 初始化匹配的产品
      let index = this.sku.findIndex(p => p[this.opts.list.id] === this.currentValue[this.opts.value.id])
      if (index !== -1) {
        this.currentSku = this.sku[index]
        // 生成当前属性值key-value数组
        this.keys.forEach(k => {
          this.values[k] = this.currentSku[k]
        })
      } else return
      this.setAttrSelected()
      this.setDisabled()
    },
    setAttrSelected () { // 设置选中的商品属性
      this.currentProps.forEach(prod => {
        prod.children.forEach(attr => {
          let index = Object.values(this.values).indexOf(attr[this.opts.sku.id])
          if (index !== -1) {
            this.$set(attr, '$selected', true)
          } else {
            this.$set(attr, '$selected', false)
          }
        })
      })
    },
    /**
     * @description 处理spu属性禁用项
     * 数据量不大，三重又如何
     * 优化思路：每次都进行了多余的运算，先找出所有的路径，覆盖当前选中值集合后判断该路径是否存在于路径集合中
     * @author yangyu
     */
    setDisabled () {
      let isEmpty = this.keys.length === 0
      this.currentProps.forEach(prop => {
        let curProd = JSON.parse(JSON.stringify(this.values))
        prop.children.forEach(attr => {
          if (isEmpty) {
            this.$set(attr, '$disabled', false)
            return
          }
          if (!attr.$selected) { // 当前选中值不处理
            this.$set(
              attr
              ,'$disabled'
              ,this.isDisabled(prop.attrId, curProd, attr.attrValue)
            )
          }
        })
      })
    },
    /**
     * @description 设置当前sku
     */
    setCurrentSku (value) {
      if (this.keys.length === this.currentProps.length) { // 判断是都选中全部
        let index = -1
        for (let i = 0; i < this.sku.length; ++i) {
          let sku = this.sku[i]
          index = i
          for (let j = 0; j < this.keys.length; ++j) {
            let k = this.keys[j]
            // console.log(k)
            if (sku[k] !== value[k]) {
              index = -1
              break
            }
          }
          if (index !== -1) { // 设置当前商品
            this.currentSku = sku
            this.nums = 1
            this.$set(this.currentValue, [this.opts.value.id], this.sku[index][this.opts.list.id])
            this.$set(this.currentValue, [this.opts.value.name], this.sku[index][this.opts.list.name])
            this.$set(this.currentValue, [this.opts.value.price], this.sku[index][this.opts.list.price] <= 0 ? '面议' : `￥${this.sku[index][this.opts.list.price]}`)
            this.$set(this.currentValue, [this.opts.value.attrText], this.attrText)
            this.$set(this.currentValue, [this.opts.value.attrs], this.attrs)
            this.$emit('input', this.currentValue)
            break
          }
        }
      }
    },
    /**
     * @description sku属性改变时调用
     * @param {Object} prop sku属性
     * @param {String} key sku属性id 对于这产品列表中的id
     * @author yangyu
     */
    handleChangeProp (prop, key) {
      if (!prop.$disabled && prop.$selected) {
        // 已经选择则取消选中
        delete this.values[key]
        prop.$selected = false
      } else if (!prop.$disabled) {
        // 选中当前属性值
        prop.$selected = true
        this.values[key] = prop.attrValue
        // 处理$selected状态
        this.setAttrSelected()
      }
      if (!prop.$disabled) {
        this.keys = Object.keys(this.values) // 设置直选中的key
        this.setCurrentSku(this.values)
        this.setDisabled()
      } else {
        this.createToast('该属性组合不存在，请重新选择').show()
      }
    },
    /**
     * @description 判断是否为禁用状态
     * @param {String} key sku属性key
     * @param {String} prop sku属性值（要检测的值）
     * @author yangyu
     */
    isDisabled (key, value, prop) {
      // 改变当前属性
      value[key] = prop
      return this.isMatch(value) === -1
    },
    /**
     * @description 属性改变时，测试是否能够匹配上商品
     * 复杂度：n: 产品数 m: sku属性个数 O(n*m)
     * @param {Object} value 当前需要判断的选中值集合
     * @author yangyu
     */
    isMatch (value) {
      let index = -1
      let key = Object.keys(value)
      for (let i = 0; i < this.sku.length; ++i) {
        let sku = this.sku[i]
        index = i
        let match = true
        for (let j = 0; j < key.length; ++j) {
          let k = key[j]
          if (sku[k] !== value[k]) {
            match = false
            break
          }
        }
        if (match) break
        else index = -1
      }
      return index
    },
    /**
     * @description 求笛卡尔积 备用
     * @author yangyu
     */
    combins () { // 将数组组合
      return Array.prototype.reduce.call(arguments, (result, currentArray) => { // result结果
        let ret = []
        result.forEach(item => {
          currentArray.forEach(element => {
            ret.push(item.concat([element])) // concat返回一个新的数组，而不改变原数组
          })
        })
        return ret // ret作为下一个新的result传入
      }, [[]]) // [[]] 默认为一个二维数组
    },
    /**
     * @description 添加购物车或立即购买 前的校验
     * @author yangyu
     */
    add (cb) {
      this.loading = true
      this.$store.dispatch(types.app.GET_USER).then(res => {
        if (typeof cb === 'function') {
          cb()
        } else {
          if (!this.user.company) {
            this.createToast('请先进行企业认证').show()
            this.loading = false
          } else {
            this.$api('cart/cartInfo', {
              skuId: this.currentValue[this.opts.list.id],
              spuId: this.spu[this.opts.spu.id],
              qty: this.nums
            })().then(() => {
              // window.location = `/my/order/edit?skuId=${this.currentValue[this.opts.list.id]}&spuId=${this.spu[this.opts.spu.id]}&qty=${this.nums}`
              this.$router.push({path: '/my/order/edit', query: {skuId: this.currentValue[this.opts.list.id], spuId: this.spu[this.opts.spu.id], qty: this.nums}})
            }).catch(err => {
              this.loading = false
              this.createToast(err).show()
            })
          }
        }
      }).catch(() => {
        // 用户未登录
        let ua = window.navigator.userAgent.toLowerCase()
        let isWx = ua.match(/MicroMessenger/i) == 'micromessenger'
        let name = 'login'
        if (isWx) {
          name = 'auth'
        } else {
          // 解决push到登录页都页面显示不完整的问题（暂时没找到原因，不是savedPosition的问题， window.scrollTo(0, 0)也没用）
          window.location = `/login?${this.$config.cookie.REDRIECT_URL}=/mall/detail/?id=${this.currentValue[this.opts.list.id]}`
          return
        }
        this.$router.push({name, query: {
          [this.$config.cookie.REDRIECT_URL]: `/mall/detail/?id=${this.currentValue[this.opts.list.id]}`,
          type: isWx ? this.$config.plaltform.WX : null,
          url: `/mall/detail/?id=${this.currentValue[this.opts.list.id]}`
        }})
      })
    },
    addCart () {
      let prod = {
        spuId: this.spu[this.opts.spu.id],
        brandName: this.spu[this.opts.spu.brand], // 品牌名称
        skuId: this.currentValue[this.opts.list.id], // SKUID
        qty: this.nums // 数量
      }
      this.$api('cart/add', prod)().then(res => {
        this.loading = false
        this.createToast('添加购物车成功').show()
        this.open = false
        setTimeout(() => {
          this.$emit('add', this.currentValue)
          this.nums = 1
        }, 400)
      }).catch(err => {
        this.loading = false
        this.createToast(err).show()
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/variable.scss";
.sku-wrapper {
  position: relative;
  width: 100%;
  // height: 714px;
  height: 900px;
  overflow: hidden;
  background: #fff;
  .sku-header {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 234px;
    display: flex;
    padding: 28px 30px 0 30px;
    align-items: center;
    .closer {
      font-size: 34px;
      position: absolute;
      top: 28px;
      right: 30px;
    }
    .sku-img {
      flex: 0 0 178px;
      display: block;
      width: 178px;
      height: 178px;
    }
    .sku-summary {
      flex: 1;
      margin-left: 30px;
      .sku-name {
        font-size: 24px;
        color: $black_text;
        margin-bottom: 10px;
      }
      .sku-spec {
        font-size: 20px;
        color: #bbb;
        margin-bottom: 20px;
      }
      .sku-price {
        font-size: 24px;
        color: #f27b7b;
      }
    }
  }
  .sku-body {
    position: absolute;
    top: 234px;
    left: 0;
    right: 0;
    bottom: 100px;
    overflow: auto;
    padding: 0 30px 0 30px;
    -webkit-overflow-scrolling: touch;
    .sku-props {
      font-size: 24px;
      color: $black_text;
      overflow: hidden;
      position: relative;
      margin-top: 28px;
      &::after {
        @include border-bottom-1px( #EBEAEA);
      }
      &-name {
        margin-bottom: 28px;
        line-height: 1.36;
      }
      &-item {
        min-width: 106px;
        height: 40px;
        display: flex;
        float: left;
        border-radius: 4px;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        background: #ebeaea;
        margin-right: 20px;
        font-size: 24px;
        padding: 0 10px;
        span {
          @include nowrap;
        }
        &.active {
          color: #fff;
          background: #409bff;
        }
        &.disabled {
          color: #c6c7c7;
          text-decoration: line-through;
        }
      }
    }
    // 数量
    .nums {
      .jc-cell {
        padding-right: 0;
        padding-left: 0;
        .jc-cell-body {
          margin-left: 0;
          color: $black_text;
          font-size: 24px;
        }
      }
      &-input {
        .van-stepper {
          display: inline-block;
          button {
            height: 40px;
          }
          input {
            height: 40px;
            box-sizing: border-box;
          }
        }
        * {
          vertical-align: middle;
        }
        .unit {
          color: $black_text;
          font-size: 24px;
        }
      }
    }
  }
  .sku-footer {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 0;
    height: 100px;
    .add2cart {
      color: #fff;
      font-size: 30px;
      background: #FF8A42;
      border-color: #FF8A42;
    }
    .buy-now {
      color: #fff;
      font-size: 30px;
      background: #F15050;
      border-color: #F15050;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sku/index.vue